module.exports = __webpack_public_path__ + "static/img/Jared_Polec_mobile.dedd825.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jared_Polec_mobile.jpg
// module id = 9g7T
// module chunks = 0